module.exports = __webpack_public_path__ + "e6beee7afcb36595eb38e293aec67bb7.png";